import { useWindowSize, BREAKPOINTS_WIDTHS } from '@belong/common';
import { Text, Image, ButtonBase } from '@belong/ui';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';
import PostInspectionContentLayout from '../../../PostInspectionContentLayout/PostInspectionContentLayout';
import { getPricingAssignedEmployee } from '../utils';

type Props = {
  onPrevious?: () => void;
  onSaveAndNext: () => void;
  stepConfig: any;
  stepConfigs: any;
  stepResource: any;
};

export const Seasonality = ({
  stepResource,
  stepConfig,
  stepConfigs,
  onSaveAndNext,
  onPrevious: _onPrevious,
}: Props) => {
  const assignedEmployee = getPricingAssignedEmployee(stepResource);

  const { width } = useWindowSize();
  const isMobile = width < BREAKPOINTS_WIDTHS.LG;

  return (
    <PostInspectionContentLayout
      showCityBackground={false}
      stepConfig={stepConfig}
      stepConfigs={stepConfigs}
      title={POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.title']}
      employee={assignedEmployee}
      noOverlay
    >
      <Text variant="h3" className="mb-xs" fontWeight="semibold">
        {POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.listing_title']}
      </Text>
      <Text className="mb-2xl">
        {POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.listing_subtitle']}
      </Text>

      <div className="w-full">
        <Image
          src={
            isMobile
              ? '/pricing-flow/seasonality_mobile.svg'
              : '/pricing-flow/seasonality.svg'
          }
          alt=""
          className="mb-xl"
        />
      </div>

      <div className="mb-2xl mt-xl rounded border border-solid border-green bg-green-translucent-light p-sm">
        <Text className="mb-xs" fontWeight="semibold">
          {POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.impact_title']}
        </Text>
        <Text className="mb-xs">
          {' '}
          {POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.impact_content']}
        </Text>
      </div>

      <div className="mb-3xl mt-2xl hidden justify-center md:flex">
        <PostInspectionContentLayout.CtaButton onClick={() => onSaveAndNext()}>
          {POST_INSPECTION_FLOW_STRINGS['pricing.seasonality.cta']}
        </PostInspectionContentLayout.CtaButton>
      </div>

      <div className="my-2xl flex w-full md:hidden">
        <ButtonBase
          className="rounded h-2xl flex-1 bg-green disabled:bg-gray"
          onClick={() => onSaveAndNext()}
        >
          <Text fontWeight="semibold" className="text-white">
            Next
          </Text>
        </ButtonBase>
      </div>
    </PostInspectionContentLayout>
  );
};
